import { StyledDialog } from "../../../common/components/Dialog";
import { DialogTitle, DialogContent } from "@mui/material";
import { StyledButton } from "../../../common/components/Button";
import {
  generateNewSubscriptionLink,
  generatePaymentLink,
  savePaymentLink,
} from "../../../api/caseApi";
import { useState } from "react";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { Grid } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "@mui/material";
import Spinner from "../../../common/components/Spinner";
import { useEffect } from "react";
import QRCode from "react-qr-code";
import { serializeToString } from "xmlserializer";
import { DialogActions } from "@mui/material";
const GeneratePaymentLinkDialog = ({
  open,
  onClose,
  caseId,
  caseProgressId,
  isSubscription,
  currentPaymentLink,
  modeOfPayment,
}) => {
  const [loading, setLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");

  useEffect(() => {
    if (currentPaymentLink != null) {
      setPaymentLink(currentPaymentLink);
    } else {
      setPaymentLink("");
    }
  }, [currentPaymentLink, caseProgressId]);

  const onImageDownload = () => {
    const svg = document.getElementById("QRCode");
    const svgData = serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = "AlinaPayQR";
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  const handleGenerateLink = async (modeOfPayment) => {
    if (loading) return;
    setLoading(true);
    try {
      if (!isSubscription) {
        const response = await generatePaymentLink(
          caseProgressId,
          modeOfPayment,
          isSubscription
        );
        setPaymentLink(response.data.link);
      } else {
        const response = await generateNewSubscriptionLink(
          modeOfPayment,
          caseId,
          false
        );
        setPaymentLink(response.data.link);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle> Generate Payment Link</DialogTitle>
      <DialogContent dividers>
        <Grid container rowSpacing={2}>
          {paymentLink !== "" && (
            <Grid
              rowSpacing={2}
              container
              style={{
                border: "1px solid #d6d6d6",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "20px",
                marginTop: "20px",
              }}
            >
              <Grid item xs={5}>
                <QRCode
                  id="QRCode"
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={paymentLink}
                  viewBox={`0 0 256 256`}
                />
              </Grid>

              <Grid item xs={12}>
                <StyledButton onClick={onImageDownload} theme="green">
                  Download QR Code
                </StyledButton>
              </Grid>

              <Grid item xs={12}>
                Or
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  inputProps={{ readOnly: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            navigator.clipboard.writeText(paymentLink)
                          }
                          sx={{ width: "36px", height: "32px" }}
                        >
                          <FontAwesomeIcon fontSize="medium" icon={faCopy} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={paymentLink}
                  label={
                    paymentLink != null
                      ? paymentLink.includes("paypal")
                        ? "Paypal Link"
                          ? paymentLink.includes("xendit")
                          : "Xendit Link"
                        : "GCash Link"
                      : "Payment Link"
                  }
                />
              </Grid>
            </Grid>
          )}
          {modeOfPayment === "Paypal" && (
            <Grid item xs={12}>
              <StyledButton
                onClick={() => handleGenerateLink("Paypal")}
                theme="green"
              >
                Generate New Paypal Payment Link
              </StyledButton>
            </Grid>
          )}
          {modeOfPayment === "GCash" && (
            <Grid item xs={12}>
              <StyledButton
                onClick={() => handleGenerateLink("GCash")}
                theme="green"
              >
                Generate New GCash Payment Link
              </StyledButton>
            </Grid>
          )}

          {modeOfPayment === "Xendit" && (
            <Grid item xs={12}>
              <StyledButton
                onClick={() => handleGenerateLink("Xendit")}
                theme="green"
              >
                Generate New Xendit Payment Link
              </StyledButton>
            </Grid>
          )}

          <Grid item xs={12} style={{ display: !loading ? "none" : "inherit" }}>
            <Spinner color={"black"} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <StyledButton theme="purple" type="button" onClick={onClose}>
          Cancel
        </StyledButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default GeneratePaymentLinkDialog;
